<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">Транзакции <router-link class="btn btn-primary" :to="{ name: 'transaction-add' }">+ Добавить транзакцию</router-link></h2>

    <resource-list
      url="/transactions"
      current-sort="text"
      :show-per-page="false"
      resource-name="transactions"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'client-transactions',
  components: { resourceList },
  data () {
    return {
      fields: [
        { name: 'full_name', label: 'Клиент', sort: false },
        { name: 'amount', label: 'Сумма', sort: true, money: true },
        { name: 'transaction_type',
          label: 'Тип операции',
          sort: true,
          decorators: {
            classes: {
              'D': 'debit',
              'C': 'credit'
            },
            values: {
              'D': 'пополнение',
              'C': 'снятие'
            }
          }
        },
        { name: 'notation', label: 'Примечание', sort: true },
        { name: 'datetime', label: 'Дата и время', sort: true, datetime: true }
      ],
      filters: {
        client: this.$route.params.client_id
      },
      actionRoutes: [
        { name: 'client-transaction-details', idName: 'transaction_id', label: 'Открыть детали' }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClientTransactions.vue?9365c5da